import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'remixicon/fonts/remixicon.css'
import 'swiper/dist/css/swiper.css'

import VueScrollTo from 'vue-scrollto'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer, /* {
    options: global default options,
    events: global videojs events
  } */)


Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(VueScrollTo, {
    container: '#app'
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
